import type { Message } from '@conversia/shared-types';

/**
 * Señal del anuncio (Click-To-WhatsApp) guardada en el mensaje.
 *
 * El adapter la captura en `metadataJson.adSignal` desde
 * `contextInfo.externalAdReply`. En el teléfono el cliente ve la tarjeta del
 * anuncio completa (miniatura + título + copy); en el panel no se mostraba
 * nada, así que el equipo no sabía de qué campaña venía el lead.
 *
 * PURO.
 */
export interface AdSignal {
  sourceType?: string;
  sourceId?: string;
  sourceUrl?: string;
  /** Click-To-WhatsApp Click ID: su presencia prueba que vino de un anuncio. */
  ctwaClid?: string;
  title?: string;
  body?: string;
}

/** Lee la señal del anuncio del mensaje, o null si no vino de publicidad. */
export function adSignalDeMensaje(m: Message): AdSignal | null {
  const raw = (m.metadataJson ?? {})['adSignal'];
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  return raw as AdSignal;
}

/**
 * ¿Hay algo que mostrarle al equipo? Con sólo el `ctwaClid` ya alcanza: no hay
 * copy que pintar, pero saber que el lead vino de publicidad es el dato.
 */
export function tieneTarjetaDeAnuncio(m: Message): boolean {
  const ad = adSignalDeMensaje(m);
  if (!ad) return false;
  return Boolean(ad.title || ad.body || ad.ctwaClid || ad.sourceId || ad.sourceUrl);
}
